export const DEFAULT_ALERT_TITLE = 'Are you sure?';

export const SUCCESS_MESSAGE = {
  UPDATE: 'successfully updated!',
};
